import API_BASE_URL from './config';
const pending=new Set();
const CHOICE='connext.analytics-consent.v1', VISITOR='connext.analytics-visitor.v1';
export const analyticsChoice=()=>{try{return localStorage.getItem(CHOICE);}catch{return 'no';}};
export async function setAnalyticsChoice(enabled){
 localStorage.setItem(CHOICE,enabled?'yes':'no');
 window.dispatchEvent(new Event('analytics-choice-changed'));
 if(!enabled){
  const visitor=localStorage.getItem(VISITOR);
  if(visitor){
   await Promise.allSettled([...pending]);
   const response=await fetch(`${API_BASE_URL}/analytics/events`,{method:'DELETE',headers:{'Content-Type':'application/json'},body:JSON.stringify({visitor})});
   if(!response.ok)throw new Error('delete_failed');
   localStorage.removeItem(VISITOR);
  }
 }
}
export function analyticsId(){try{return window.crypto?.randomUUID?.();}catch{return undefined;}}
export function track(event,details={}){
 try{
  if(analyticsChoice()!=='yes')return;
  let visitor=localStorage.getItem(VISITOR);
  if(!visitor){visitor=analyticsId();if(!visitor)return;localStorage.setItem(VISITOR,visitor);}
  const id=analyticsId();if(!id)return;
  const ua=navigator.userAgent;
  const os=/Android/i.test(ua)?'Android':/iPhone|iPad|iPod/i.test(ua)||(/Macintosh/i.test(ua)&&navigator.maxTouchPoints>1)?'iOS':/Windows/i.test(ua)?'Windows':/Mac/i.test(ua)?'macOS':/Linux/i.test(ua)?'Linux':'Other';
  const browser=/Edg/i.test(ua)?'Edge':/Firefox|FxiOS/i.test(ua)?'Firefox':/Chrome|CriOS/i.test(ua)?'Chrome':/Safari/i.test(ua)?'Safari':'Other';
  const payload={id,visitor,event,consent_version:1,os,browser};
  // Explicit allowlist: never send arbitrary objects, SDP, error text or profile data.
  for(const key of ['call_id','duration_ms','kind'])if(details[key]!==undefined)payload[key]=details[key];
  const request=fetch(`${API_BASE_URL}/analytics/events`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),keepalive:true}).catch(()=>{});
  pending.add(request);request.finally(()=>pending.delete(request));
 }catch{/* Analytics must never interrupt a call. */}
}
